module.exports = __webpack_public_path__ + "img/gradeA.709c234a.png";